//弹窗拖拽
const modaldrag = function (e) {
  var modalBox = document.querySelector(".commom-modal");
  e = e || window.event;
  var x = e.pageX - modalBox.offsetLeft;
  var y = e.pageY - modalBox.offsetTop;
  document.onmousemove = function (e) {
    document
      .querySelector("body")
      .setAttribute("style", "user-select: none;cursor:all-scroll;");
    var boxX = e.pageX - x;
    var boxY = e.pageY - y;
    modalBox.style.top = boxY + "px";
    modalBox.style.left = boxX + "px";
    if (boxY < 0) {
      document.onmousemove = null;
      modalBox.style.top = 0;
    }
  };
  document.onmouseup = function () {
    document.onmousemove = null;
    document
      .querySelector("body")
      .setAttribute("style", "user-select: auto;cursor:auto;");
  };
};

//弹窗拉伸
const modaldraw = function (e) {
  var modalBox = document.querySelector(".commom-modal");
  var orginWidth = modalBox.offsetWidth;
  var originHeight = modalBox.offsetHeight;
  e = e || window.event;
  var x = e.clientX;
  var y = e.clientY;
  document.onmousemove = function (e) {
    document
      .querySelector("body")
      .setAttribute("style", "user-select: none;cursor:se-resize;");
    var boxX = e.clientX - x;
    var boxY = e.clientY - y;
    // console.log("Y："+boxY)
    // console.log("X："+boxX)
    if (boxX > 0) {
      modalBox.style.width = orginWidth + boxX + "px";
    } else {
      if (parseInt(modalBox.style.width) <= 450) {
        modalBox.style.width = 450 + "px";
      } else {
        modalBox.style.width = orginWidth + boxX + "px";
      }
    }
    if (boxY > 0) {
      modalBox.style.height = originHeight + boxY + "px";
    } else {
      if (parseInt(modalBox.style.height) <= 450) {
        modalBox.style.height = 450 + "px";
      } else {
        modalBox.style.height = originHeight + boxY + "px";
      }
    }
  };
  document.onmouseup = function () {
    document.onmousemove = null;
    document
      .querySelector("body")
      .setAttribute("style", "user-select: auto;cursor:auto;");
  };
};

//设置modal加载居中
// window.onload=function(){
//     var modalBox=document.querySelector('.commom-modal')
//     console.log(modalBox)
//     var selfWidth=parseInt(modalBox.style.width)
//     var windowWidth=window.innerWidth
//     modalBox.style.left=(windowWidth-selfWidth)*0.5+"px"
//     console.log("触发了")
// }
export default {
  modaldrag,
  modaldraw,
};
